import { CATEGORIES_LIVE_GET } from "@common/constants/action-types";
export default function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case CATEGORIES_LIVE_GET:
            return action.payload;
        default:
            return state;
    }
}
